import { useEffect } from "react";
import { useLocation } from "react-router-dom";
 
function ScrollToTop() {
  const { pathname, search } = useLocation();
 
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
 
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname, search]);
 
  return null;
}
 
export default ScrollToTop;